import React from 'react'
import { useValues } from 'kea'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

import I18n from 'lib/i18n'
import { getSharePayload } from 'lib/utils/courses/share'

import Action from '~/scenes/course/list/course-actions/action'

import iconsMap from '../../social-media-icons'

import courseLogic from '~/scenes/course/show/logic'

const Share = () => {
  const { course, facebookApp } = useValues(courseLogic)

  const isRetina = typeof window !== 'undefined' && window.devicePixelRatio >= 2

  const share = (event, type) => {
    const { shareUrl, title } = course
    event.preventDefault()
    window.open(...getSharePayload(type, shareUrl, title, facebookApp))
  }

  const handleClick = (event, type) => share(event, type)

  return (
    <div className='widget nospace white' id='sharebox'>
      <h3 className='boxtitle line'>{I18n.t('courses.show_share.title')}</h3>
      <div className='big-padding'>
        <LazyLoadComponent>
          {['mail', 'messenger', 'whatsapp', 'facebook', 'twitter', 'linkedin'].map(type => (
            <Action
              key={`key-${type}`}
              onClick={event => handleClick(event, type)}
              className='social-media-icon'
              icon={type === 'mail' ? 'share-icon icon1 letter_closed' : `share-icon ${type}`}
              title={I18n.t(`courses.show.share_service.${type}`)}
              iconStyle={
                type === 'mail'
                  ? {}
                  : {
                      backgroundImage: `url(${isRetina ? iconsMap[`${type}2X`] : iconsMap[type]})`,
                      backgroundRepeat: 'no-repeat'
                    }
              }
            />
          ))}
        </LazyLoadComponent>
      </div>
    </div>
  )
}

export default Share
